import React, { Component } from 'react';
import config from "./../config.json";

class PersonelCard extends Component {

  state = {
    values: this.props.values,
  }

  componentDidMount() {
    if (this.state.values.kullanici.resim == null) {
      this.setState({ values: { ...this.state.values, kullanici: { ...this.state.values.kullanici, resim: config.blankPhoto } } });
    }
  }

  onClick = (event) => {
    this.props.parentCallback(this.state.values);
    event.preventDefault();
  }

  contextMenu= (e) => {
    e.preventDefault();
  }

  getImageSource = (resim) => {
    if (!resim) {
      return config.blankPhoto;
    }
    return String(resim).startsWith('data:image') ? resim : config.imageEndpoint + resim;
  }

  render() {
    return <div className="col">
      <div className="card h-100">
        <img className="card-img-top" alt="Personel Profil Fotoğrafı" loading="lazy" data-bs-toggle="modal" type="button" onClick={this.onClick} data-bs-target="#modalCenter" src={this.getImageSource(this.state.values.kullanici['resim'])} onContextMenu={this.contextMenu}/>
        <div className="card-body">
          <h5 className="card-title">{this.state.values.kullanici['ad']} {this.state.values.kullanici['soyad']}</h5>
          <p className="card-text">
            {this.state.values.kullanici['departmanAdi']} - {this.state.values.kullanici['gorevi']}
          </p>
        </div>
        <div className="modal-footer"><button onClick={this.onClick}
          type="button"
          className="btn btn-outline-primary "
          data-bs-toggle="modal"
          data-bs-target="#modalCenter">Detay
        </button></div>
      </div>
    </div>;
  }

}

export default PersonelCard;
